import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { FormHelperText, Grid } from '@material-ui/core';
import FormikSelect from 'catalyst/core/form/Select/variants/FormikSelect';
import { convertForms } from 'utils/selectConversions';
import { Button } from 'catalyst/core';

const NewForm = ({ forms, submitForm, choices }) => {
    const validationSchema = {
        choice: yup.string().required('Required').nullable(),
        formId: yup.string().when('choice', (choice) => {
            if (choice === choices.NEW) {
                return yup.string().nullable();
            } else {
                return yup.string().required('Form Is Required').nullable();
            }
        }),
    };

    const items = [
        {
            value: choices.NEW,
            label: 'New Form',
        },
        {
            value: choices.EXISTING,
            label: 'Use Existing Form',
        },
        {
            value: choices.COPY,
            label: 'Use form as Template',
        },
    ];

    const initialValues = {
        choice: choices.NEW,
        formId: null,
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                console.log(values);
                submitForm(values);
            }}
            validationSchema={yup.object(validationSchema)}
        >
            {({ submitForm, isSubmitting, errors, touched, values }) => {
                const submit = (event) => {
                    event.preventDefault();
                    submitForm();
                };

                const enabled =
                    values.choice === choices.EXISTING ||
                    values.choice === choices.COPY;

                const name = 'formId';
                const err =
                    touched && errors && touched[name] && Boolean(errors[name]);
                const text = touched && errors && touched[name] && errors[name];

                return (
                    <Grid style={{ padding: '15px' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-end"
                            spacing={1}
                            style={{ marginBottom: '10px' }}
                        >
                            <Grid item xs={12}>
                                <FormikSelect
                                    id={'choice'}
                                    label={'Action'}
                                    name={'choice'}
                                    items={items}
                                    style={{ minWidth: '300px' }}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-end"
                            spacing={1}
                            style={{ marginBottom: '10px' }}
                        >
                            <Grid item xs={12}>
                                <FormikSelect
                                    id={'formId'}
                                    label={'Forms'}
                                    name={'formId'}
                                    items={convertForms(forms)}
                                    style={{ minWidth: '300px' }}
                                    fullWidth
                                    disabled={!enabled}
                                />
                                {err && <FormHelperText>{text}</FormHelperText>}
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-end"
                            spacing={1}
                        >
                            <Grid item xs={12}>
                                <Button
                                    onClick={submit}
                                    color={'primary'}
                                    variant={'contained'}
                                    fullWidth
                                >
                                    Create Custom Form
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                );
            }}
        </Formik>
    );
};

export default NewForm;
